import { useEffect, useState } from 'react'
import { Building2, ChevronDown } from 'lucide-react'
import { ACTIVE_SUPPLIER, setSupplier, SUPPLIERS } from '../tenant'
import { fetchManufacturers, type ManufacturerOption } from '../landing'
import { SearchableSelect } from './SearchableSelect'

// Admin god-view picker: "logged in as" any manufacturer. The list is DATA-DRIVEN from
// /api/manufacturers — every manufacturer in the data (Olof sees all ~47), not a hardcoded
// roster. Onboarded ones show their official name; the rest a top-brand-derived label.
// Selecting persists + reloads so the whole app re-scopes. (Only rendered for admins; the
// endpoint is admin-only, so the options are exactly what the server lets this seat pick.)
//
// A CUSTOM dropdown, not a native <select>: macOS positions a native popup so the SELECTED
// option sits over the control, so with "All manufacturers" (the last item) selected it opened
// UPWARD — you can't force a native popup's direction with CSS. This menu opens downward, from
// the top of the list (Olof 31/8: "dropdownen ska droppa ner och börja uppifrån och ner"),
// flipping up only when there is no room below.
//
// MP-OS-189 — ~56 names is too many to scroll: it is the shared SearchableSelect (type to
// filter on the display name, keyboard, Escape/focus return); the pill is its face.
const MARKET: ManufacturerOption = { value: '', label: 'All suppliers (whole market)', dosor: 0, onboarded: true }

export function SupplierPicker() {
  // Seed with the onboarded suppliers so there's no empty flash / a fallback if the
  // fetch fails; replaced by the full live list once it loads.
  const seed = SUPPLIERS.filter((s) => s.manufacturer).map((s) => ({
    value: s.manufacturer,
    label: s.label,
    dosor: 0,
    onboarded: true,
  }))
  const [opts, setOpts] = useState<ManufacturerOption[]>([...seed, MARKET])

  useEffect(() => {
    void fetchManufacturers().then((list) => {
      if (list.length) setOpts([...list, MARKET])
    })
  }, [])

  const current = ACTIVE_SUPPLIER.manufacturer
  const currentLabel = opts.find((o) => o.value === current)?.label ?? ACTIVE_SUPPLIER.label

  return (
    <SearchableSelect
      className="supplier-picker"
      // Transparent trigger covers the whole pill so a click anywhere opens the menu.
      triggerClassName="sp-trigger"
      label="View as supplier"
      searchLabel="Search suppliers"
      showAllLabel="Show all suppliers"
      title="View as supplier (admin)"
      options={opts}
      value={current}
      placeholder={ACTIVE_SUPPLIER.label}
      onChange={(value) => setSupplier(value, opts.find((o) => o.value === value)?.label ?? value)}
      adornment={
        <>
          <Building2 size={15} className="sp-icon" aria-hidden />
          <span className="sp-value">{currentLabel}</span>
          <ChevronDown size={15} className="sp-caret" aria-hidden />
        </>
      }
    />
  )
}
